import { fromJS, List, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

import { TeamCustomRoleSummaryItem } from './TeamCustomRoleSummaryItem';

type TeamCustomRoleSummaryProps = {
  totalCount: number;
  items: List<TeamCustomRoleSummaryItem>;
};

export class TeamCustomRoleSummary extends Record<TeamCustomRoleSummaryProps>({
  totalCount: 0,
  items: List(),
}) {}

export const createTeamCustomRoleSummary = (props?: CreateFunctionInput<TeamCustomRoleSummary>) => {
  const teamCustomRoleSummary =
    props instanceof TeamCustomRoleSummary ? props : new TeamCustomRoleSummary(fromJS(props));

  return teamCustomRoleSummary.withMutations((summary) => {
    summary.update('items', (items) => items.map((role) => new TeamCustomRoleSummaryItem(role)));
  });
};
